import React, { PureComponent } from "react";
import {
  PieChart,
  Pie,
  Sector,
  Cell,
  ResponsiveContainer,
  Legend,
  Tooltip,
} from "recharts";

// const data = [
//   { name: 'Group A', value: 12 },
//   { name: 'Group B', value: 56 },
//   { name: 'Group C', value: 31 },
// ]

const COLORS = ["url(#gra1)", "url(#gra2)", "url(#gra3)", "#FF8042"];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};


export default function PieGraph2(param) {
  let result = [];
  if (param.param !== undefined) {
    // console.log("pie2 param:", param);
    const data = param.param.total_warning_dict;

    if (data !== undefined) {
      data.map((item) => {
        const tempObject = {
          name: item.wa_type,
          value: item.occurrence_count,
        };
        result.push(tempObject);
      });
    }

    // if (data === undefined || data.length === 0) {
    //   const tempObject = {
    //     name: "No Data",
    //     value: 1,
    //   };
    //   result.push(tempObject);
    // } else {
    //   if (data !== undefined) {
    //     data.map((item) => {
    //       const tempObject = {
    //         name: item.wa_type,
    //         value: item.occurrence_count,
    //       };
    //       result.push(tempObject);
    //     });
    //   }
    // }
  }

  return (
    <div style={{ width: 150, height: 150 }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <defs>
            <linearGradient
              id="gra1"
              x1="0"
              y1="0"
              x2="0"
              y2="100%"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#bababa" />
              <stop offset=".6" stopColor="#8740CD" />
              <stop offset="1" stopColor="#580475" />
            </linearGradient>
          </defs>
          <defs>
            <linearGradient
              id="gra2"
              x1="0"
              y1="0"
              x2="0"
              y2="100%"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#628EFF" />
              <stop offset=".6" stopColor="#19CEE2" />
              <stop offset="1" stopColor="#0E717C" />
            </linearGradient>
          </defs>
          <defs>
            <linearGradient
              id="gra3"
              x1="0"
              y1="0"
              x2="0"
              y2="100%"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#071b6d" />
              <stop offset=".6" stopColor="#0F37DB" />
              <stop offset="1" stopColor="#f0f0f0" />
            </linearGradient>
          </defs>
          <Pie
            data={result}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={renderCustomizedLabel}
            outerRadius={70}
            fill="url(#gra1)"
            dataKey="value"
          >
            {result &&
              result.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
          </Pie>
          <Tooltip enabled={true} cornerRadius={15}></Tooltip>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
